import { HelpOutlineRounded } from '@/constants/hardfin-standard-icons';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';

interface Props {
  listPath: Pick<LinkProps, 'to' | 'params' | 'search'>;
  listLabel: string;
}

export function Entity404(props: Props) {
  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="400px"
      padding={4}
    >
      <HelpOutlineRounded
        sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }}
      />
      <Typography variant="h1" component="h1" gutterBottom>
        404
      </Typography>
      <Typography variant="h4" component="h2" gutterBottom>
        Page not found
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        textAlign="center"
        maxWidth="400px"
        marginBottom={4}
      >
        The page you're looking for doesn't exist or has been moved. Let's get
        you back on track.
      </Typography>
      <Stack direction="row" spacing={2}>
        <Link
          {...props.listPath}
          replace={true}
          style={{ textDecoration: 'none' }}
        >
          <Button variant="contained">{props.listLabel}</Button>
        </Link>
        <Button variant="outlined" onClick={handleGoBack}>
          Go back
        </Button>
      </Stack>
    </Box>
  );
}
